import isEqual from 'lodash/isEqual'
import type {Moment} from 'moment-timezone'

// Use a `Moment` as an extra dependency tracking change by `moment.isSame`
export const sameExtra = (value: Moment) => ({
  value,
  comparator: (a: Moment, b: Moment) => a.isSame(b)
})

// Use set semantics (same elements, order agnostic) to track dependency changes
export function sameSetExtra<A, B>(values: A[], f: (x: A) => B) {
  return {
    value: values,
    comparator: (vs1: A[], vs2: A[]) => isEqual(new Set(vs1.map(f)), new Set(vs2.map(f)))
  }
}

// Use an an extra dependency tracking change by `lodash/isEqual`
export function equalExtra<T>(value: T) {
  return {
    value,
    comparator: isEqual
  }
}

interface HasId {
  id: string
}

export const idExtraDep = <V extends HasId>(value: V) => ({
  value,
  comparator: (a: V, b: V) => a.id === b.id
})

// Use an an extra dependency tracking change by `a.id === b.id`
export function equalIdExtra<TId>(value: {id: TId}) {
  return {
    value,
    comparator: (s1: {id: TId}, s2: {id: TId}) => s1.id === s2.id
  }
}

// Use an an extra dependency which is unchanging
export function staticExtra<T>(value: T) {
  return {
    value,
    comparator: (_: T, __: T) => true
  }
}
